export const selectCountries = (state) => state.countries.allCountries;
